import React, { Component } from 'react';
import { Form } from 'antd';
import ReportDescription from './ReportDescription'
import PrintersSelectTable from './PrintersSelectTable'
import {getReportParam} from '../utils/EmailReportsHelper'
import {REPORT_URL} from '../utils/constants'

const layout = {
    labelCol: {
        offset: 0,
        span: 1,
    },
/*    
    wrapperCol: {       
        offset: 0,
        span: 6,
    },
*/    
  };

const report_type_name = "Report.Meters";
const printer_id_name = "printer_id";
const report_url = "/printers_values";

class MetersReportStep2 extends Component {

    constructor(props) {
        super(props);

        this.printer_id = this.getPrinterId();
        this.savePrinterId(this.printer_id);

        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url);
      }

    savePrinterId(printer_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, printer_id_name, printer_id);
    }

    getPrinterId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, printer_id_name, this.props.report.url);
    }

    onSelectChange(selectedRowKeys) {
        this.printer_id = selectedRowKeys[0];
        this.savePrinterId(this.printer_id);
    }

    render() {
    
        return (
            <div style={{align:"left", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                >
                <Form.Item>
                    <PrintersSelectTable 
                    printer_id = {this.printer_id}
                    onSelectChange = {(selectedRowKeys) => this.onSelectChange(selectedRowKeys)}/>
                </Form.Item>
                </Form>
                <ReportDescription description="Report.Meters.Description"/>         
            </div>
        );
      }
}

export default MetersReportStep2;